var _a;
import { DogRecipeInfo } from '@content/products/meals';
import beefRecipePDP1Src from '@images/marketing/PDPs/BeefPage-Carousel-1.jpg';
import beefRecipePDP2Src from '@images/marketing/PDPs/BeefPage-Carousel-2.jpg';
import beefRecipePDP3Src from '@images/marketing/PDPs/BeefPage-Carousel-3.jpg';
import chickenRecipePDP1Src from '@images/marketing/PDPs/ChickenPage-Carousel-1.jpg';
import chickenRecipePDP2Src from '@images/marketing/PDPs/ChickenPage-Carousel-2.jpg';
import chickenRecipePDP3Src from '@images/marketing/PDPs/ChickenPage-Carousel-3.jpg';
import lambRecipePDP1Src from '@images/marketing/PDPs/LambPage-Carousel-1.jpg';
import lambRecipePDP2Src from '@images/marketing/PDPs/LambPage-Carousel-2.jpg';
import lambRecipePDP3Src from '@images/marketing/PDPs/LambPage-Carousel-3.jpg';
import porkRecipePDP1Src from '@images/marketing/PDPs/PorkPage-Carousel-1.jpg';
import porkRecipePDP2Src from '@images/marketing/PDPs/PorkPage-Carousel-2.jpg';
import porkRecipePDP3Src from '@images/marketing/PDPs/PorkPage-Carousel-3.jpg';
import samplerPackPDP1Src from '@images/marketing/PDPs/SamplerPack-Carousel-1.jpg';
import turkeyChickenRecipePDP1Src from '@images/marketing/PDPs/TurkeyChickenPage-Carousel-1.jpg';
import turkeyChickenRecipePDP2Src from '@images/marketing/PDPs/TurkeyChickenPage-Carousel-2.jpg';
import turkeyChickenRecipePDP3Src from '@images/marketing/PDPs/TurkeyChickenPage-Carousel-3.jpg';
import turkeyRecipePDP1Src from '@images/marketing/PDPs/TurkeyPage-Carousel-1.jpg';
import turkeyRecipePDP2Src from '@images/marketing/PDPs/TurkeyPage-Carousel-2.jpg';
import turkeyRecipePDP3Src from '@images/marketing/PDPs/TurkeyPage-Carousel-3.jpg';
import beefRecipeFunnelSrc from '@images/marketing/funnel/Funnel-Meals-beef.jpg';
import chickenRecipeFunnelSrc from '@images/marketing/funnel/Funnel-Meals-chicken.jpg';
import lampRecipeFunnelSrc from '@images/marketing/funnel/Funnel-Meals-lamb.jpg';
import porkRecipeFunnelSrc from '@images/marketing/funnel/Funnel-Meals-pork.jpg';
import turkeyRecipeFunnelSrc from '@images/marketing/funnel/Funnel-Meals-turkey.jpg';
import turkeyChickenRecipeFunnelSrc from '@images/marketing/funnel/Funnel-Meals-turkey_chicken.jpg';
import beefMashSrc from '@images/marketing/product_cards/meals-beef.png';
import chickenCuisineSrc from '@images/marketing/product_cards/meals-chicken.png';
import lambPilafSrc from '@images/marketing/product_cards/meals-lamb.png';
import porkPotluckSrc from '@images/marketing/product_cards/meals-pork.png';
import turkeyFareSrc from '@images/marketing/product_cards/meals-turkey.png';
import turkeyChickenCookoutSrc from '@images/marketing/product_cards/meals-turkey_chicken.png';
import samplerPackTileSrc from '@images/marketing/product_cards/sampler-pack.jpg';
import samplerPackSrc from '@images/marketing/product_cards/sampler-pack.png';
// The values of these enums are used as the slugs in their
// page (PDP) urls
var MealName;
(function (MealName) {
    MealName["Beef"] = "beef";
    MealName["Chicken"] = "chicken";
    MealName["Lamb"] = "lamb";
    MealName["Pork"] = "pork";
    MealName["Turkey"] = "turkey";
    MealName["TurkeyChicken"] = "turkey_chicken";
    MealName["SamplerPack"] = "sampler-pack";
    // Old name for the sampler pack, used for legacy URLs
    MealName["SamplerPackOldName"] = "variety-pack-dogs-200g";
})(MealName || (MealName = {}));
MealName;
var recipeInfo = (_a = {},
    _a[MealName.Beef] = {
        displayName: 'Beef Mash',
        get tileDisplayName() {
            return this.displayName;
        },
        ingredients: 'Beef, Potatoes, Eggs, Carrots, Peas',
        fullIngredients: DogRecipeInfo.beef.ingredients,
        nutritionInfo: DogRecipeInfo.beef.nutritionInfo,
        slug: MealName.Beef,
        priceLevel: 4,
        productId: MealName.Beef,
        image: {
            src: beefMashSrc,
            alt: 'A package and bowl of Beef Mash',
        },
        funnelImage: {
            src: beefRecipeFunnelSrc,
            alt: 'Beef Mash',
        },
        pdpImages: [
            {
                src: beefRecipePDP1Src,
                alt: 'Beef Mash Individual Packaging',
            },
            {
                src: beefRecipePDP2Src,
                alt: 'Beef Mash Multi Pack',
            },
            {
                src: beefRecipePDP3Src,
                alt: 'A dog eats a Beef Mash meal from a bowl',
            },
        ],
        isActive: true,
        isNew: false,
        url: "/meals/".concat(MealName.Beef),
    },
    _a[MealName.Chicken] = {
        displayName: 'Chicken Cuisine',
        get tileDisplayName() {
            return this.displayName;
        },
        ingredients: 'Chicken, Sweet Potatoes, Squash, Spinach',
        fullIngredients: DogRecipeInfo.chicken.ingredients,
        nutritionInfo: DogRecipeInfo.chicken.nutritionInfo,
        slug: MealName.Chicken,
        priceLevel: 2,
        productId: MealName.Chicken,
        image: {
            src: chickenCuisineSrc,
            alt: 'A package and bowl of Chicken Cuisine',
        },
        funnelImage: {
            src: chickenRecipeFunnelSrc,
            alt: 'Chicken Cuisine',
        },
        pdpImages: [
            {
                src: chickenRecipePDP1Src,
                alt: 'Chicken Cuisine Individual Packaging',
            },
            {
                src: chickenRecipePDP2Src,
                alt: 'Chicken Cuisine Multi Pack',
            },
            {
                src: chickenRecipePDP3Src,
                alt: 'A dog eats a Chicken Cuisine meal from a bowl',
            },
        ],
        isActive: true,
        isNew: false,
        url: "/meals/".concat(MealName.Chicken),
    },
    _a[MealName.Pork] = {
        displayName: 'Pork Potluck',
        get tileDisplayName() {
            return this.displayName;
        },
        ingredients: 'Pork, Potatoes, Green Beans, Squash, Kale, Mushrooms',
        fullIngredients: DogRecipeInfo.pork.ingredients,
        nutritionInfo: DogRecipeInfo.pork.nutritionInfo,
        slug: MealName.Pork,
        priceLevel: 3,
        productId: MealName.Pork,
        image: {
            src: porkPotluckSrc,
            alt: 'A package and bowl of Pork Potluck',
        },
        funnelImage: {
            src: porkRecipeFunnelSrc,
            alt: 'Pork Potluck',
        },
        pdpImages: [
            {
                src: porkRecipePDP1Src,
                alt: 'Pork Potluck Individual Packaging',
            },
            {
                src: porkRecipePDP2Src,
                alt: 'Pork Potluck Multi Pack',
            },
            {
                src: porkRecipePDP3Src,
                alt: 'A dog eats a Pork Potluck meal from a bowl',
            },
        ],
        isActive: true,
        isNew: false,
        url: "/meals/".concat(MealName.Pork),
    },
    _a[MealName.Turkey] = {
        displayName: 'Turkey Fare',
        get tileDisplayName() {
            return this.displayName;
        },
        ingredients: 'Turkey, Brown Rice, Eggs, Carrots, Spinach',
        fullIngredients: DogRecipeInfo.turkey.ingredients,
        nutritionInfo: DogRecipeInfo.turkey.nutritionInfo,
        slug: MealName.Turkey,
        priceLevel: 3,
        productId: MealName.Turkey,
        image: {
            src: turkeyFareSrc,
            alt: 'A package and bowl of Turkey Fare',
        },
        funnelImage: {
            src: turkeyRecipeFunnelSrc,
            alt: 'Turkey Fare',
        },
        pdpImages: [
            {
                src: turkeyRecipePDP1Src,
                alt: 'Turkey Fare Individual Packaging',
            },
            {
                src: turkeyRecipePDP2Src,
                alt: 'Turkey Fare Multi Pack',
            },
            {
                src: turkeyRecipePDP3Src,
                alt: 'A dog eats a Turkey Fare meal from a bowl',
            },
        ],
        isActive: true,
        isNew: false,
        url: "/meals/".concat(MealName.Turkey),
    },
    _a[MealName.Lamb] = {
        displayName: 'Lamb Pilaf',
        get tileDisplayName() {
            return this.displayName;
        },
        ingredients: 'Lamb, Rice, Eggs, Carrots, Peas',
        fullIngredients: DogRecipeInfo.lamb.ingredients,
        nutritionInfo: DogRecipeInfo.lamb.nutritionInfo,
        slug: MealName.Lamb,
        priceLevel: 4,
        productId: MealName.Lamb,
        image: {
            src: lambPilafSrc,
            alt: 'A package and bowl of Lamb Pilaf',
        },
        funnelImage: {
            src: lampRecipeFunnelSrc,
            alt: 'Lamb Pilaf',
        },
        pdpImages: [
            {
                src: lambRecipePDP1Src,
                alt: 'Lamb Pilaf Individual Packaging',
            },
            {
                src: lambRecipePDP2Src,
                alt: 'Lamb Pilaf Multi Pack',
            },
            {
                src: lambRecipePDP3Src,
                alt: 'A dog eats a Lamb Pilaf meal from a bowl',
            },
        ],
        isActive: true,
        isNew: true,
        url: "/meals/".concat(MealName.Lamb),
    },
    _a[MealName.TurkeyChicken] = {
        displayName: 'Turkey & Chicken Cookout',
        get tileDisplayName() {
            return this.displayName;
        },
        ingredients: 'Turkey, Chicken, Sweet Potatoes, Kale, Eggs, Peas',
        fullIngredients: DogRecipeInfo.turkey_chicken.ingredients,
        nutritionInfo: DogRecipeInfo.turkey_chicken.nutritionInfo,
        slug: MealName.TurkeyChicken,
        priceLevel: 3,
        productId: MealName.TurkeyChicken,
        image: {
            src: turkeyChickenCookoutSrc,
            alt: 'A package and bowl of Turkey & Chicken Cookout',
        },
        funnelImage: {
            src: turkeyChickenRecipeFunnelSrc,
            alt: 'Turkey & Chicken Cookout',
        },
        pdpImages: [
            {
                src: turkeyChickenRecipePDP1Src,
                alt: 'Turkey & Chicken Cookout Individual Packaging',
            },
            {
                src: turkeyChickenRecipePDP2Src,
                alt: 'Turkey & Chicken Cookout Multi Pack',
            },
            {
                src: turkeyChickenRecipePDP3Src,
                alt: 'A dog eats a Turkey & Chicken Cookout meal from a bowl',
            },
        ],
        isActive: true,
        isNew: true,
        url: "/meals/".concat(MealName.TurkeyChicken),
    },
    _a[MealName.SamplerPack] = {
        displayName: 'Sampler Pack',
        get tileDisplayName() {
            return this.displayName;
        },
        slug: MealName.SamplerPack,
        ingredients: 'A variety of our dog food recipes at a tasty price',
        price: 20,
        productId: MealName.SamplerPack,
        isNew: false,
        isActive: true,
        image: {
            src: samplerPackSrc,
            alt: 'Our meals Sampler Pack',
        },
        tileImage: {
            src: samplerPackTileSrc,
            alt: 'Our meals Sampler Pack',
        },
        pdpImages: [
            {
                src: samplerPackPDP1Src,
                alt: 'Sampler Pack With Individual Packaging',
            },
        ],
        url: "/meals/".concat(MealName.SamplerPack),
    },
    _a);
recipeInfo[MealName.SamplerPackOldName] = recipeInfo[MealName.SamplerPack];
export { recipeInfo, MealName };
